import type { CSSProperties } from 'react';
import { Colors } from '@/lib/utils/common/colors';

interface VisualizationColorSwatchProps {
  color: string;
  label: string;
}

export function VisualizationColorSwatch({ color, label }: VisualizationColorSwatchProps) {
  const squareStyles: CSSProperties = {
    backgroundColor: color,
    borderColor: `#${Colors.gray200.hex}`,
  };

  return (
    <div className={`flex items-center gap-2 p-2 pl-3 w-full min-w-0 ${Colors.white.bg}`}>
      <div className="w-[14px] h-[14px] rounded border shrink-0" style={squareStyles} />
      <div className="flex-1 min-w-0">
        <div className={`text-xs line-clamp-1 break-all ${Colors.gray600.text}`}>{label}</div>
      </div>
    </div>
  );
}
